"use strict";
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.buildTabExportText = exports.buildDefaultPaneTabKeys = exports.getMaxReaderColumns = exports.buildUseCaseDetailTabs = void 0;
var markdown_text_1 = require("./markdown-text");
var markdown_headings_1 = require("./markdown-headings");
var info_tab_builder_1 = require("./info-tab-builder");
var rehype_sanitize_1 = require("./rehype-sanitize");
Object.defineProperty(exports, "rehypeSanitizeMarkdown", { enumerable: true, get: function () { return rehype_sanitize_1.rehypeSanitizeMarkdown; } });
var markdown_text_2 = require("./markdown-text");
Object.defineProperty(exports, "buildMarkdownListSection", { enumerable: true, get: function () { return markdown_text_2.buildMarkdownListSection; } });
Object.defineProperty(exports, "buildMarkdownTable", { enumerable: true, get: function () { return markdown_text_2.buildMarkdownTable; } });
Object.defineProperty(exports, "normalizeReportText", { enumerable: true, get: function () { return markdown_text_2.normalizeReportText; } });
Object.defineProperty(exports, "splitCommaSeparatedValues", { enumerable: true, get: function () { return markdown_text_2.splitCommaSeparatedValues; } });
Object.defineProperty(exports, "splitDashListValues", { enumerable: true, get: function () { return markdown_text_2.splitDashListValues; } });
Object.defineProperty(exports, "splitOrderedListValues", { enumerable: true, get: function () { return markdown_text_2.splitOrderedListValues; } });
Object.defineProperty(exports, "toMarkdownValue", { enumerable: true, get: function () { return markdown_text_2.toMarkdownValue; } });
var markdown_headings_2 = require("./markdown-headings");
Object.defineProperty(exports, "extractMarkdownHeadings", { enumerable: true, get: function () { return markdown_headings_2.extractMarkdownHeadings; } });
Object.defineProperty(exports, "slugifyHeading", { enumerable: true, get: function () { return markdown_headings_2.slugifyHeading; } });
Object.defineProperty(exports, "splitMarkdownIntoSections", { enumerable: true, get: function () { return markdown_headings_2.splitMarkdownIntoSections; } });
var field_coercion_1 = require("./field-coercion");
Object.defineProperty(exports, "coerceFieldValueToString", { enumerable: true, get: function () { return field_coercion_1.coerceFieldValueToString; } });
Object.defineProperty(exports, "formatCreatedAt", { enumerable: true, get: function () { return field_coercion_1.formatCreatedAt; } });
Object.defineProperty(exports, "getOutputFieldValue", { enumerable: true, get: function () { return field_coercion_1.getOutputFieldValue; } });
Object.defineProperty(exports, "getTargetSystemId", { enumerable: true, get: function () { return field_coercion_1.getTargetSystemId; } });
var info_tab_builder_2 = require("./info-tab-builder");
Object.defineProperty(exports, "buildInfoTabMarkdown", { enumerable: true, get: function () { return info_tab_builder_2.buildInfoTabMarkdown; } });
/**
 * Build the set of UI tabs from the output payload.
 */
exports.buildUseCaseDetailTabs = function (useCase, output, strategies) {
    var orderedResults = __spreadArrays(((output === null || output === void 0 ? void 0 : output.UseCaseResults) || [])).sort(function (left, right) { return left.Order - right.Order; });
    var infoMarkdown = info_tab_builder_1.buildInfoTabMarkdown(useCase, output, strategies);
    var infoHeadings = markdown_headings_1.extractMarkdownHeadings(infoMarkdown, 'info');
    var markdownTabs = [
        {
            key: 'info',
            title: 'Use Case',
            kind: 'markdown',
            markdown: infoMarkdown,
            headings: infoHeadings,
            sections: markdown_headings_1.splitMarkdownIntoSections(infoMarkdown, infoHeadings),
        },
    ];
    orderedResults.forEach(function (result) {
        // The report `Text` payload is already authored as pure Markdown — pass
        // it through verbatim (only normalizing line endings and HTML entities)
        // so we don't mangle tables, lists, or headings with extra heuristics.
        var markdown = markdown_text_1.normalizeReportText(result.Text);
        var headings = markdown_headings_1.extractMarkdownHeadings(markdown, result.Title);
        markdownTabs.push({
            key: markdown_headings_1.slugifyHeading(result.Title),
            title: result.Title,
            kind: 'markdown',
            markdown: markdown,
            headings: headings,
            sections: markdown_headings_1.splitMarkdownIntoSections(markdown, headings),
        });
    });
    var allMarkdown = markdownTabs
        .filter(function (tab) { return tab.key !== 'info'; })
        .map(function (tab) { return tab.markdown; })
        .join('\n\n---\n\n');
    var allHeadings = markdownTabs.reduce(function (result, tab) { return result.concat(tab.headings); }, []);
    return markdownTabs.concat([
        {
            key: 'alignment',
            title: 'Use Case Alignment',
            kind: 'alignment',
            markdown: '',
            headings: [
                {
                    id: 'alignment-graph',
                    level: 1,
                    text: 'Alignment Graph',
                },
            ],
            sections: [],
        },
        {
            key: 'all',
            title: 'All In One Page',
            kind: 'all',
            markdown: allMarkdown,
            headings: allHeadings.concat([
                {
                    id: 'alignment-graph',
                    level: 1,
                    text: 'Alignment Graph',
                },
            ]),
            sections: [],
        },
    ]);
};
/**
 * Determine the maximum sensible column count for the current width.
 */
exports.getMaxReaderColumns = function (viewportWidth) {
    if (viewportWidth >= 1800) {
        return 3;
    }
    if (viewportWidth >= 1280) {
        return 2;
    }
    return 1;
};
/**
 * Build default pane selections for multi-column view.
 */
exports.buildDefaultPaneTabKeys = function (tabs, paneCount) {
    var candidateTabs = tabs.filter(function (tab) { return tab.key !== 'all'; });
    return new Array(paneCount).fill(null).map(function (_value, index) {
        return candidateTabs[index] ? candidateTabs[index].key : candidateTabs[0].key;
    });
};
/**
 * Generate exportable text for a given tab.
 */
exports.buildTabExportText = function (tab) {
    if (tab.kind === 'alignment') {
        return tab.title + "\n\nUse Case Alignment visualization.";
    }
    return tab.title + "\n\n" + tab.markdown;
};
